module.exports = __webpack_public_path__ + "static/media/self-pic.8b08eeca.jpg";